<template>
    <main-content-wrapper>
        <h1 class="text-md-center">
            POZABLJENO GESLO
            <span>
                Ste pozabili vaše geslo? Vpišite vaš e-naslov na katerega vam bomo poslali povezavo
            preko katere spremenite geslo.
            </span>
        </h1>
        <v-layout justify-center row wrap fill-height >
            <v-flex xs12 md6 pl-5 pr-5 pt-4 pb-4 class="border">
                <v-alert
                        :value="invalid_username"
                        type="error"
                >
                    Nepoznan elektronski naslov.
                </v-alert>
                <empty-space v-if="invalid_username" />
                <v-form v-model="valid" @submit.prevent="" ref="form">
                    <email-field v-model="email" type="email" required label="Vaš email naslov" v-on:keypress.enter="forgotPassword" autofocus />
                </v-form>
                <v-btn depressed large block color="primary_action" @click="forgotPassword" :loading="loading">PONASTAVITE GESLO</v-btn>
            </v-flex>
        </v-layout>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import EmailField from "../components/EmailField";
    import EmptySpace from "../components/EmptySpace";
    import utils from "../store/utils";

    export default {
        name: "ForgotPassword",
        data: vm => ({
            valid: false,
            email: null
        }),
        components: {MainContentWrapper, EmptySpace, EmailField},
        computed:{
            loading: utils.vuexBuildSetGet(this, 'auth', 'loading'),
            invalid_username: utils.vuexBuildSetGet(this, 'auth', 'invalid_username')
        },
        methods: {
            forgotPassword() {
                let isValid = this.$refs.form.validate();
                if (isValid) {
                    this.$store.dispatch('auth/forgotPassword', {username: this.email});
                }
            }
        }
    };

</script>

<style scoped>

</style>